<div class="local-filter" [hidden]="total <= 7"> 
	<input placeholder="{{ 'FILTER' | translate | lowercase }}..." [formControl]="filter"> 
	<a class="search-button button icon-only join-left"><i class="fa fa-search"></i></a>
</div>